import { render } from "./Heading.vue?vue&type=template&id=55c4e462&scoped=true"
import script from "./Heading.vue?vue&type=script&lang=js"
export * from "./Heading.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-55c4e462"

export default script